module.exports = __webpack_public_path__ + "static/media/sign.a7f3bf16.jpg";